const styles = () => ({
  cell: {
    textAlign: 'center',
  },
});

export default styles;
